module.exports = '/ng-templates/util/util.tpl.ftl';
